
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {IArtistJson} from "../../../server/src/modules/shared-interfaces";

@Component
export default class ArtistImage extends Vue {
    @Prop() artist!: IArtistJson;
    @Prop({ default: '6rem' }) width!: string;
    @Prop({ default: '6rem' }) height!: string;
}
